import React from "react";
import styles from "./titulo.module.css";

const Titulo = ({ titulo }) => {
    return (
        <div className={styles.container}>
            <div className={styles.titulo}>
                <label>{titulo}</label>
            </div>
        </div>
    )
}

export default Titulo;